import { useEffect } from "react";
import { useState } from "react";
import Whatsapp from "../Shared/Whatsapp";
import CustomerComments from "./CustomerComments";
import Footer from "./Footer";
import { useTranslation } from "react-i18next";
import InformativeWall from "./InformativeWall";
import Allies from "./Allies";
//import TournamentInvitation from "../Shared/TournamentInvitation";
import OurServices from "../System/OurServices";
import LoginForm from "../Login/LoginForm";
import { UseAuth } from "src/auth/AuthContext";
import { classNames, getProfileDefaultImage } from "src/helpers/mixins";
import { useParams } from "react-router-dom";
import APIService from "src/services/Api";
import SimulateMoney from "./SimulateMoney";
import RegisterForm from "../Register/RegisterForm";
import DialogInfoGeneral from "../Shared/DialogInfoGeneral";
import { Cashier } from "src/types";
import UserLoggedInMessage from "../System/UserLoggedInMessage";
import CashierInvitation from "../System/CashierInvitation";

 

const BodyLanding = () => {
  const { t } = useTranslation();
  const { isAuthenticated, user } = UseAuth();
  const { apodo } = useParams();
  const [cashier, setCashier] = useState<Cashier>();
  const [showPresentation, setShowPresentation] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(true);
  const [waitAnimation, setWaitAnimation] = useState(true);

  const fetchCashier = async () => {
    const token = await APIService.getToken();
    localStorage.setItem("accessToken", token.data.data.accessToken);
    const f = await APIService.CashierByApodo({ apodo });
    if (f?.data?.data?.findconfig) {
      setCashier(f?.data?.data?.findconfig);
      setTimeout(() => {
        setWaitAnimation(false);
      }, 1500);
    }
  };

  const nodeDescriptionCashier = () => {
    return (
      <div className="flex flex-col items-center justify-center py-10 opensans">
        <div className="text-lg font-light md:text-2xl fadein">
          <div>Bienvenido a mi perfil de cajero</div>
          <div className="text-center mt-4">
            <div>Hola!, soy</div>
            <div className="pt-4 text-base md:text-lg capitalize font-medium">
              {cashier?.fullname}
            </div>
          </div>
        </div>
        <div className="font-light text-base mt-6 fadeinbottom">
          Nos alegra que estés aquí
        </div>

        <div className="flex flex-col fadeinbottom items-center mt-4 bg-gradient-card border border-b-2 border-stone-300 px-6 md:px-8 py-10 rounded-md">
          {!waitAnimation ? (
            <div
              className="w-28 h-28 bg-cover bg-center rounded-full appear "
              style={{
                backgroundImage: `url(${
                  (cashier?.photoUrl?.length || 0) > 0
                    ? process.env.REACT_APP_PROFILEPICTURE +
                      (cashier?.photoUrl || "")
                    : getProfileDefaultImage()
                })`,
              }}
            ></div>
          ) : (
            <div className="flex items-center w-28 h-28 justify-center"></div>
          )}
          <div className="text-xl mt-6 font-normal opensans appear text-stone-700 uppercase">
            {cashier?.nickname}
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [loading]);

  useEffect(() => {
    if (!!apodo?.length) {
      fetchCashier();
    }
  }, [apodo]);

  return (
    <div>
      {(cashier?.id?.length || 0) > 0 && cashier && (
        <div>
          <div className="bg-cashier-page">
            <div className="w-full h-2"></div>
            {!isAuthenticated ?
              <div className="opensans w-fit fadeintop mx-auto bg-gradient-to-r from-stone-500 to-stone-800 text-white text-center text-base sm:text-base md:text-xl px-10 py-2 rounded-md mb-10 uppercase mt-4 font-bold">
                ¡Registrate! como usuario e intercambia tus saldos digitales.
              </div>
              :
              <div className="w-full h-10"></div>
            }
            <div
              className={classNames( !isAuthenticated 
                  ? "md:grid-cols-2"
                  : "md:grid-cols-1",
                "w-full xl:w-10/12 grid-cols-1 mx-auto grid gap-y-4"
              )}
            >
              <div className={classNames( isAuthenticated ? 'lg:w-1/2': 'md:w-11/12', " w-11/12 mx-auto rounded-sm")}>
                {cashier?.id && (
                  <SimulateMoney
                    photo={cashier?.photoUrl}
                    cashierId={cashier.id}
                    fullname={cashier?.fullname}
                    nickname={cashier?.nickname}
                    cashierProcessors={cashier?.CashierProcessors}
                    timePayment={cashier?.timeDeposit}
                  />
                )}
              </div>
              {!isAuthenticated && 
                <div className="relative w-full">
                  <div className="w-11/12 relative  mx-auto rounded-sm register-white-sheet">
                    {cashier?.id && (
                      <RegisterForm
                        role="user"
                        cashierFather={cashier?.id}
                        disableImage={true}
                        disabledBackground={true}
                      />
                    )}
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      )}
      {apodo && (apodo?.length || 0) > 0 && cashier && (
        <DialogInfoGeneral
          show={showPresentation}
          closeDialog={() => setShowPresentation(false)}
          children={nodeDescriptionCashier()}
        />
      )}
      {!isAuthenticated ? <LoginForm /> : 
      
      <UserLoggedInMessage userName={user?.fullname || ''} userImage={user?.photoUrl || ''} />
      }
        {/*<TournamentInvitation /> */}
        <CashierInvitation />
      <OurServices />
      <Allies />
      {/*loading ? (
        <div className="skeleton-loading w-full">
          &nbsp;
          <div
            className="loading-block-dark"
            style={{ width: "90%", height: "65vh", margin: "0 auto" }}
          >
            &nbsp;
          </div>
        </div>
      ) : (
        <MainCarrousel />
      )*/}

      <InformativeWall />
      {/*<div className="mt-14">
        <Community />
      </div>*/}
      <div className="customer-say-header bg-stone-200">
        {loading ? (
          <div className="skeleton-loading w-full">
            &nbsp;
            <div
              className="loading-block-dark"
              style={{ width: "90%", height: "65vh", margin: "0 auto" }}
            >
              &nbsp;
            </div>
          </div>
        ) : (
          <CustomerComments />
        )}
      </div>

      <Whatsapp />
      <Footer />
    </div>
  );
};

export default BodyLanding;
